import React, { useContext, useEffect, useState } from 'react'

import { GlobalContext } from 'core/contexts/global-context'
import useInterval from 'core/hooks/use-interval'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

let interval = null

const Background = props => {
  const global = useContext(GlobalContext)
  const [backgroundIndex, setBackgroundIndex] = useState(null)
  const [background, setBackground] = useState(null)

  const rotate = Array.isArray(global.background) && global.background.length > 1

  const advance = () => {
    if (typeof global.background === 'string') return
    if (!rotate) return
    const nextIndex = backgroundIndex >= global.background.length - 1 ? 0 : backgroundIndex + 1
    setBackgroundIndex(nextIndex)
    setBackground(global.background[nextIndex])
  }

  useEffect(() => {
    setBackgroundIndex(0)
    const bg = rotate ? global.background[0] : global.background
    setBackground(bg)
  }, [global.background])

  const int = useInterval(advance, rotate ? 5000 : null)

  const handleBackgroundClick = () => {
    advance()
    int.reset()
  }

  const style = {
    backgroundImage: background ? `url(${background})` : null
  }

  return (
    <div className="background" onClick={handleBackgroundClick}>
      <TransitionGroup>
        <CSSTransition key={background} timeout={500} classNames="background-item" unmountOnExit>
          <div className="background-item" style={style}></div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  )
}

export default Background
